/**
 * Right-pane selection union for the Voluum Standard paths workspace.
 *
 * Three exclusive selections:
 *  - default-path : edit a default-path detail (existing behavior)
 *  - group-conditions : edit a rule group's conditions (new editor)
 *  - group-path : edit a path inside a rule group (same detail editor)
 */

export type PathsSelection =
  | { kind: 'default-path'; index: number }
  | { kind: 'group-conditions'; groupIndex: number }
  | { kind: 'group-path'; groupIndex: number; pathIndex: number };

export const defaultPathSelection = (index: number): PathsSelection => ({
  kind: 'default-path',
  index,
});

export const groupConditionsSelection = (
  groupIndex: number,
): PathsSelection => ({ kind: 'group-conditions', groupIndex });

export const groupPathSelection = (
  groupIndex: number,
  pathIndex: number,
): PathsSelection => ({ kind: 'group-path', groupIndex, pathIndex });

export function isDefaultPathSelected(
  s: PathsSelection,
  index: number,
): boolean {
  return s.kind === 'default-path' && s.index === index;
}

export function isGroupSelected(
  s: PathsSelection,
  groupIndex: number,
): boolean {
  return (
    (s.kind === 'group-conditions' && s.groupIndex === groupIndex) ||
    (s.kind === 'group-path' && s.groupIndex === groupIndex)
  );
}

export function isGroupPathSelected(
  s: PathsSelection,
  groupIndex: number,
  pathIndex: number,
): boolean {
  return (
    s.kind === 'group-path' &&
    s.groupIndex === groupIndex &&
    s.pathIndex === pathIndex
  );
}
